export var FilterOrSearch;
(function (FilterOrSearch) {
    FilterOrSearch["Filter"] = "Filter";
    FilterOrSearch["Search"] = "Search";
    FilterOrSearch["Empty"] = "Empty";
})(FilterOrSearch || (FilterOrSearch = {}));
export const ComputeListConstants = {
    SET_PARTIAL_USER_CONTEXT: 'computeList/SET_PARTIAL_USER_CONTEXT',
};
export const getDefaultState = () => {
    return {
        userContext: {
            debug_useFakeData: false,
            filter: null,
            search: null,
            filterOrSearch: FilterOrSearch.Empty,
        },
    };
};
const setPartialUserContext = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { userContext: Object.assign(Object.assign({}, state.userContext), actionResult.payload) });
};
export function setPartialUserContextFunc(userContext) {
    return {
        type: ComputeListConstants.SET_PARTIAL_USER_CONTEXT,
        payload: userContext,
    };
}
export const ComputeListReducer = (state = getDefaultState(), actionResult) => {
    switch (actionResult.type) {
        case ComputeListConstants.SET_PARTIAL_USER_CONTEXT:
            return setPartialUserContext(state, actionResult);
        default:
            return state;
    }
};
export default ComputeListReducer;

//# sourceMappingURL=ComputeListFilter.ducks.js.map
